import moment from "moment";
import { useNavigate } from "react-router-dom";

export const ViolationPointCard = (props: any) => {
    const { data } = props
    const navigate = useNavigate()
    return <div
        className=" flex flex-col gap-2">
        <div
            className="bg-white p-3 rounded-xl flex-col flex gap-3 w-full justify-between"
        >
            <div className="flex justify-between text-[12px]">
                <div>
                    <span className="text-psp-gray">
                        {moment(props.data[`${props.type}Date`]).format('DD MMMM YYYY')}
                    </span>
                    <span className="flex flex-col text-lg">
                        {props.data[`${props.type}Master`]?.name || 'Poin Pelanggaran'}
                    </span>
                    <span className={props.type === 'reward' ? "text-[#FFBE0C]" : "text-[#FF000C]"}>
                        {props.data[`${props.type}Master`]?.point}&nbsp;Point</span>
                    <button
                        onClick={() => navigate(`/point-guard/${props.type}/${props.data._id}`)}
                        className=" flex flex-row gap-2 mt-3 px-3 py-1 border-1 border-[#0054e6] text-[#0054e6] font-medium text-xs rounded-md"
                    >
                        Detail
                    </button>
                </div>
                <img
                    src={props.getProfileImage('')}
                    className="size-20 object-cover rounded-xl"
                />
            </div>
        </div>
    </div>
};